export default __webpack_public_path__ + "static/char-v-49-zh-Hant-f7aed48acacdec9f51fc7161c9119098.mp4";